<div class="content justify-content-center align-items-center">
  <div class="row d-flex flex-row justify-content-between ml-4 pl-2 mr-3">
    <p class="text-upper">Today</p>
  </div>
  <div
    class="row d-flex flex-row justify-content-between ml-4 pl-3 mr-3"
    *ngFor="let item of activities"
  >
    <div class="icon">
      <img src="assets/svg/ico-unlock.svg" />
    </div>

    <div class="title mr-auto pl-3">
      <p class="text-upper">{{ item.state }} - {{ item.unit }}</p>
      <p class="text-lower">By: {{ item.operator }}</p>
    </div>

    <div class="date">
      <p class="text-upper">{{ item.day }}</p>
      <p class="text-lower">{{ item.time }}</p>
    </div>
  </div>
</div>
